<template>
	<div class="g-product-card g-product-card__hoverable g-layout__item js-gtm-impression" :data-gtm-name="result.name" :data-gtm-id="result.code" :data-gtm-price="result.price">
		<a class="g-product-card__link" :href="result.url | rewriteUrl" :title="result.name">
			<div class="g-product-card__image">
				<span v-if="flag" :class="`g-product-flag g-flag-${flagType}`">{{ flag }}</span>

				<img v-lazy="{ src: result.thumbnailImageUrl, error: errorImage, loading: loadingImage }" :alt="''" class="g-product-card__image-source"/>
			</div>

			<div class="g-product-card__footer">
				<span v-if="result.cmn_name?.length" class="g-product-card__brand">{{ result.name }}</span>

				<div class="g-product-card__name" v-html="displayName"></div>

				<div class="g-product-card__information">
					<div v-if="result.variant_price_range?.length" class="g-product-card__pricing">
						<span class="g-product-card__price">{{ result.variant_price_range }}</span>
					</div>
					<div v-else class="g-product-card__pricing">
						<span :class="['g-product-card__price', {'g-product-card__price--sale': result.base_price > result.price}]">{{ result.price | toCurrency }}</span>

						<s v-if="result.base_price > result.price" class="g-product-card__base-price">{{ result.base_price | toCurrency }}</s>
					</div>

					<div v-if="availabilityItems?.length" class="g-product-card__availability">
						<div v-for="(item) in availabilityItems" :key="item.name" class="g-product-card__availability-item">
							<span :class="`g-product-card__availability-item-icon ${item.icon}`" aria-hidden="true"></span>
							<span v-if="item.name" class="u-hide-visually">{{ item.name }}</span>
						</div>
					</div>
				</div>
			</div>
		</a>
	</div>
</template>

<script>
	import {hidePlantIcons} from '../../common-functions';

	export default {
		data() {
			return {
				errorImage: mivaJS.Image_Placeholder_Product_Empty,
				loadingImage: mivaJS.Image_Placeholder_Product
			}
		},
		props: {
			result: {
				default() {
					return {};
				}
			}
		},
		computed: {
			availabilityItems () {
				if (hidePlantIcons()) {
					return [];
				}

				if (!this.result.availability?.length) {
					return [{
						icon: 'u-icon-seeds-circle u-icon--placeholder'
					}];
				}

				const availabilityItems = [];

				Array.from(new Set(this.result.availability))
					.forEach((item) => {
						let icon = '';
						const itemFormatted = item.toUpperCase();

						switch (itemFormatted) {
							case 'BARE ROOT PLANTS':
								icon = 'u-icon-root-plants-circle';

								break;

							case 'POTTED PLANTS':
								icon = 'u-icon-potted-plants-circle';

								break;

							case 'SEEDS':
								icon = 'u-icon-seeds-circle';

								break;

							default:
								break;
						}

						if (icon === '') {
							return;
						}

						const newItem = {
							icon: icon,
							name: item
						};

						if (itemFormatted === 'SEEDS') {
							availabilityItems.unshift(newItem);
						} else {
							availabilityItems.push(newItem);
						}
					});

				return availabilityItems;
			},
			displayName () {
				return this.result.cmn_name?.length ? this.result.cmn_name : this.result.name;
			},
			flag () {
				return this.result.product_flag?.length ? this.result.product_flag : '';
			},
			flagType () {
				switch (this.flag.toLowerCase()) {
					case 'sale':
						return 'sale';
					case 'popular':
						return 'featured';
					case 'exclusive':
					case 'new':
					case 'notify':
					case 'sold out':
						return 'new';
				}

				return '';
			}
		}
	}
</script>
